

import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import { EVENT } from '../../../common/events/listEvents';
import BetslipAction from '../../BetslipComponent/BetslipAction';
import Utils from '../../../common/Utils';
import withRouter from '../../../common/decorator/withRouter';
import _ from 'lodash';

/**
 * Use this component to get new status of waiting bet items. 
 */
@translate([], {wait: true})
@withRouter
@inject('BetslipStore')
@observer
class ProcessingBetItemComponent extends Component {

  constructor(props) {
    super(props);
    this.fetchMyBetsData = this.fetchMyBetsData.bind(this);
  }

  componentDidMount() {
    window.listenEvent(EVENT.CALL_MY_BETS_SERVICE, this.fetchMyBetsData);
  }

  componentWillUnmount() {
    window.stopListenEvent(EVENT.CALL_MY_BETS_SERVICE, this.fetchMyBetsData)   
    clearInterval(this.intervalId);
  }
  
  onClickToastLink = () => {
    this.props.history.push('/' + Utils.getCurrentLang() + '/pending-bets');
  }

  fetchMyBetsData() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.intervalId = setInterval(() => this.doFetchMyBetsData(), Utils.betslipWagerRefreshTime());
  }
  
  doFetchMyBetsData() {
    
    const showPendingToast = this.props.BetslipStore.isShowPendingToast; // user closes the bet slip then toast will be used  to notify when the bet was accepted

    BetslipAction.callMyBets().then(rs => {
      if (rs) {
        const processingQueue = this.props.BetslipStore.getProcessingQueue;
        const normalBetsResponse = this.props.BetslipStore.getNormalBetsResponse;
        const parlayBetsRes = this.props.BetslipStore.getParlayBetsResponse;
        if (showPendingToast && processingQueue.length > 0) {
          this.props.BetslipStore.changeStatusOfPendingBet(processingQueue, rs);
          BetslipAction.showToastAfterPendingBetAccepted(processingQueue, this.props.BetslipStore, this.props.t, this.onClickToastLink);
        } else if (!_.isNil(parlayBetsRes.legs)) {
          this.props.BetslipStore.changeStatusOfParlayPendingBet(parlayBetsRes, rs);
        } else {
          this.props.BetslipStore.changeStatusOfPendingBet(normalBetsResponse, rs);
        }
        if (processingQueue.length < 1 && showPendingToast) {
          clearInterval(this.intervalId);
          this.props.BetslipStore.triggerShowPendingToast(false);
        }
      } else {
        Utils.showToastError();
      }
    });
  }


  render() {
    return (
      <React.Fragment>
        
      </React.Fragment>
    )
  }
}
export default ProcessingBetItemComponent;


// WEBPACK FOOTER //
// ./src/app/components/BaseComponent/ProcessingBetItemComponent/index.js